/* eslint-disable jsx-a11y/anchor-is-valid */
// @flow
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// components
import Table from '../../components/Table';
import { useTranslation } from 'react-i18next';
import { Loading } from 'react-loading-ui';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { getAlertSummary, getUserRequestAPI } from '../../API/RDPMS_API';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import '../../../src/assets/scss/custom/components/_alert.scss';
import '../dashboard/Dashboard/Dashboard.css';
import HyperDatepicker from '../../components/Datepicker';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import { alertSummaryColumns, mapRequestDataToOptions, sizePerPageList } from './requestDataMapper';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import PieChartComponent from '../../components/Charts/PieChartComponent';
import GraphChartComponent from '../../components/Charts/GraphChartComponent';
import BarChartComponent from '../../components/Charts/BarChartComponent';

const AlertSummary = () => {
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));
    const userRole = auth?.user?.role;

    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const [selectedViews, setSelectedViews] = useState({ value: 'table', label: 'Table' });

    const [pieData, setPieData] = useState([]);
    const [barData, setBarData] = useState([]);
    const [graphData, setGraphData] = useState([]);

    const [selectedStartDate, setSelectedStartDate] = useState(() => {
        const now = new Date();
        const last24Hours = new Date();
        last24Hours.setHours(now.getHours() - 24);
        return last24Hours;
    });

    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [selectedZones, setSelectedZones] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedDivisions, setSelectedDivisions] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedStation, setSelectedStation] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedAssetsType, setSelectedAssetsType] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedAssetsNumber, setSelectedAssetsNumber] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedAlertType, setSelectedAlertType] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedCauses, setSelectedCauses] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);

    const [stations, setStations] = useState([]);
    const [zones, setZones] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [assetsTypeCode, setAssetsTypeCode] = useState([]);
    const [assetsType, setAssetsType] = useState([]);
    const [assetsNumber, setAssetsNumber] = useState([]);
    const [alertType, setAlertType] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
        {
            label: 'Failure',
            value: 'FAILURE',
        },
        {
            label: 'Prediction',
            value: 'PREDICTION',
        },
    ]);
    const [causes, setCauses] = useState([]);

    const [statusMessage, setStatusMessage] = useState('');
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        const fetchStation = async () => {
            await getRequestData(auth.user.id);
        };

        fetchStation();
    }, []);

    useEffect(() => {
        if (stations && stations.length > 0) {
            getAlertSummaryData(limit, pageNumber);
        }
    }, [stations]);

    const formatDateTime = (date) => {
        if (!date) return {};

        return {
            date: `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(
                2,
                '0'
            )}/${date.getFullYear()}`,
            time: `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(
                date.getSeconds()
            ).padStart(2, '0')}`,
        };
    };

    // const getAlertSummaryData = async (limits, pages) => {
    //     Loading();

    //     let limitNumber = limits ?? limit;
    //     let pagesNumber = pages ?? pageNumber;

    //     const { date: start_date, time: start_time } = formatDateTime(selectedStartDate);
    //     const { date: end_date, time: end_time } = formatDateTime(selectedEndDate);

    //     const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);
    //     const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

    //     let station = [];
    //     if (userRole === 'super admin') {
    //         station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
    //     } else {
    //         if (selectedStation.length > 0 && !selectedStation.some((s) => s.value === 'all')) {
    //             station = selectedStation.map((s) => s.value);
    //         } else {
    //             station = stations.filter((s) => s.value !== 'all').map((s) => s.value);
    //         }
    //     }

    //     const assetsType = selectedAssetsType.some((a) => a.value === 'all')
    //         ? []
    //         : selectedAssetsType.map((a) => a.value);
    //     const alertType = selectedAlertType.some((a) => a.value === 'all') ? [] : selectedAlertType.map((a) => a.value);
    //     const assetsNumber = selectedAssetsNumber.some((item) => item.value === 'all')
    //         ? []
    //         : selectedAssetsNumber.map((item) => ({ sc: item.sc, asset_number_code: item.label }));
    //     const causesArray = selectedCauses.some((c) => c.value === 'all') ? [] : selectedCauses.map((c) => c.value);

    //     // Always send page_size 0 / page_number 0 to get ALL records from API
    //     let request = {
    //         start_date,
    //         start_time,
    //         end_date,
    //         end_time,
    //         request: {
    //             zone,
    //             division,
    //             station,
    //             asset_type: assetsType,
    //             alert_type: alertType,
    //             asset_number: assetsNumber,
    //             cause: causesArray,
    //         },
    //         page_number: 0, // always fetch all
    //         page_size: 0, // always fetch all
    //     };

    //     let response = await getAlertSummary(request);

    //     if (response) {
    //         const allDataArray = [];

    //         const pieDataMap = {};
    //         const barDataMap = {};
    //         const graphDataMap = {};

    //         response?.zone?.forEach((zone) => {
    //             zone.division?.forEach((division) => {
    //                 division.station?.forEach((station) => {
    //                     station.alert_type?.forEach((at) => {
    //                         const alertTypeName = at.alert_type_name || at.alert_type_code || 'UNKNOWN';
    //                         let alertResolved = 0;

    //                         at.asset_type?.forEach((ast) => {
    //                             ast.asset_number?.forEach((asn) => {
    //                                 asn.cause?.forEach((c) => {
    //                                     const resolvedPercentage = c.resolved_percentage ?? 0;
    //                                     alertResolved += resolvedPercentage;

    //                                     allDataArray.push({
    //                                         vcc: response.vcc || '',
    //                                         vcn: response.vcn || '',
    //                                         zoneCode: zone.zc || '',
    //                                         divisionCode: division.dc || '',
    //                                         stationCode: station.sc || '',
    //                                         alertType: alertTypeName,
    //                                         assetType: ast.astc || '',
    //                                         assetNumber: asn.asnc || '',
    //                                         causeCode: c.cause_code || '',
    //                                         totalCount: c.total_count ?? 0,
    //                                         trueCount: c.true_count ?? 0,
    //                                         partiallyTrueCount: c.partially_true_count ?? 0,
    //                                         resolvedPercentage,
    //                                     });
    //                                 });
    //                             });
    //                         });

    //                         pieDataMap[alertTypeName] = (pieDataMap[alertTypeName] || 0) + alertResolved;
    //                         barDataMap[alertTypeName] = (barDataMap[alertTypeName] || 0) + alertResolved;
    //                         graphDataMap[alertTypeName] = (graphDataMap[alertTypeName] || 0) + alertResolved;
    //                     });
    //                 });
    //             });
    //         });

    //         // Chart data
    //         setPieData(Object.keys(pieDataMap).map((key) => ({ name: key, value: pieDataMap[key] })));
    //         setBarData(Object.keys(barDataMap).map((key) => ({ name: key, total: barDataMap[key] })));
    //         setGraphData(Object.keys(graphDataMap).map((key) => ({ name: key, value: graphDataMap[key] })));

    //         // Frontend pagination
    //         const fullTotal = allDataArray.length;

    //         if (limitNumber > 0) {
    //             const startIndex = (pagesNumber - 1) * limitNumber;
    //             const endIndex = startIndex + limitNumber;
    //             const pagedData = allDataArray.slice(startIndex, endIndex);

    //             // Assign srNo after slicing
    //             const numberedData = pagedData.map((row, i) => ({
    //                 ...row,
    //                 srNo: startIndex + i + 1,
    //             }));

    //             setData(numberedData);
    //             setPageNumber(pagesNumber);
    //             setPageCount(Math.ceil(fullTotal / limitNumber));
    //             setTotalCount(fullTotal);
    //         } else {
    //             // Chart view — no pagination needed
    //             const numberedData = allDataArray.map((row, i) => ({ ...row, srNo: i + 1 }));
    //             setData(numberedData);
    //             setPageNumber(1);
    //             setPageCount(1);
    //             setTotalCount(fullTotal);
    //         }

    //         setStatusMessage('Alerts summary fetched successfully');
    //     }

    //     Loading();
    // };

    const getAlertSummaryData = async (limits, pages) => {
        if (isFetching) return;
        setIsFetching(true);
        Loading();

        let limitNumber = limits ?? limit;
        let pagesNumber = pages ?? pageNumber;

        const { date: start_date, time: start_time } = formatDateTime(selectedStartDate);
        const { date: end_date, time: end_time } = formatDateTime(selectedEndDate);

        const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);
        const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

        let station = [];
        if (userRole === 'super admin') {
            station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
        } else {
            if (selectedStation.length > 0 && !selectedStation.some((s) => s.value === 'all')) {
                station = selectedStation.map((s) => s.value);
            } else {
                station = stations.filter((s) => s.value !== 'all').map((s) => s.value);
            }
        }

        const assetsType = selectedAssetsType.some((a) => a.value === 'all')
            ? []
            : selectedAssetsType.map((a) => a.value);
        const alertType = selectedAlertType.some((a) => a.value === 'all') ? [] : selectedAlertType.map((a) => a.value);
        const assetsNumber = selectedAssetsNumber.some((item) => item.value === 'all')
            ? []
            : selectedAssetsNumber.map((item) => ({ sc: item.sc, asset_number_code: item.label }));
        const causesArray = selectedCauses.some((c) => c.value === 'all') ? [] : selectedCauses.map((c) => c.value);

        // Backend se hamesha FULL data mangwate hain (page 0/0), pagination/aggregation
        // backend me ek pass me ho chuka hai — yahan sirf table view ke liye client-side slice
        let request = {
            start_date,
            start_time,
            end_date,
            end_time,
            request: {
                zone,
                division,
                station,
                asset_type: assetsType,
                alert_type: alertType,
                asset_number: assetsNumber,
                cause: causesArray,
            },
            page_number: 0,
            page_size: 0,
        };

        let response = await getAlertSummary(request);

        if (response && response.isSuccess !== false) {
            // Backend se seedha mapped rows — koi nested loop nahi
            const allDataArray = response?.tableRows || [];

            // Chart data — backend se already aggregated
            setPieData((response?.pieRows || []).map((r) => ({ name: r.alertType, value: r.value })));
            setBarData((response?.barRows || []).map((r) => ({ name: r.alertType, total: r.total })));
            setGraphData((response?.graphRows || []).map((r) => ({ name: r.alertType, value: r.value })));

            // Frontend pagination (table view ke liye)
            const fullTotal = allDataArray.length;

            if (limitNumber > 0) {
                const startIndex = (pagesNumber - 1) * limitNumber;
                const endIndex = startIndex + limitNumber;
                const pagedData = allDataArray.slice(startIndex, endIndex);

                const numberedData = pagedData.map((row, i) => ({
                    ...row,
                    srNo: startIndex + i + 1,
                }));

                setData(numberedData);
                setPageNumber(pagesNumber);
                setPageCount(Math.ceil(fullTotal / limitNumber) || 1);
                setTotalCount(fullTotal);
            } else {
                const numberedData = allDataArray.map((row, i) => ({ ...row, srNo: i + 1 }));
                setData(numberedData);
                setPageNumber(1);
                setPageCount(1);
                setTotalCount(fullTotal);
            }

            setStatusMessage(fullTotal ? 'Alerts summary fetched successfully' : 'No data found');
        } else {
            setData([]);
            setPieData([]);
            setBarData([]);
            setGraphData([]);
            setPageCount(1);
            setTotalCount(0);
            setStatusMessage('Data fetch failed, please try again');
        }

        Loading();
        setIsFetching(false);
    };

    const getRequestData = async (id) => {
        try {
            Loading(true);

            const response = await getUserRequestAPI(id);

            if (response) {
                const { stations, zones, divisions, assetsType, assetsTypeCode, assetsNumber, causes } =
                    mapRequestDataToOptions(response);

                // Component state me directly set
                setStations(stations);
                setZones(zones);
                setDivisions(divisions);
                setAssetsType(assetsType);
                setAssetsTypeCode(assetsTypeCode);
                setAssetsNumber(assetsNumber);
                setCauses(causes);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            Loading(false);
        }
    };

    //pagination
    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getAlertSummaryData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getAlertSummaryData(limit, value);
    };

    const viewOptions = [
        { label: 'Table', value: 'table' },
        { label: 'Pie', value: 'pie' },
        { label: 'Bar', value: 'bar' },
        { label: 'Graph', value: 'graph' },
    ];

    const handleSelectView = async (e) => {
        if (e?.value === 'table') {
            await getAlertSummaryData(5, 1);
        } else {
            await getAlertSummaryData(0, 0);
        }
        setSelectedViews(e);
    };

    const downloadSummaryExcel = () => {
        const exportData = data.map((row) => ({
            'Sr Number': row.srNo,
            'Vendor Name': row.vcc,
            'Zone Code': row.zoneCode,
            'Division Code': row.divisionCode,
            'Station Code': row.stationCode,
            'Alert Type': row.alertType,
            'Asset Type': row.assetType,
            'Asset Number': row.assetNumber,
            'Cause Code': row.causeCode,
            'Total Count': row.totalCount,
            'True Count': row.trueCount,
            'Partially True Count': row.partiallyTrueCount,
            '% of (True + Partially True) Alerts out of Total Alerts': row.resolvedPercentage,
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Alert Summary');

        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });

        const blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        });

        saveAs(blob, 'Alert_Summary.xlsx');
    };

    return (
        <>
            <ToastContainer />

            <div className=" py-3 " style={{ width: '100%' }}>
                {/* <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                      
                        <div className="col-12 col-md-auto">
                            <button className="btn_1 w-100" style={{ marginLeft: '0' }}>
                                Alert Summary
                            </button>
                        </div>
                    </div>
                </div> */}

                <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                        <div className="col-12 col-md-auto">
                            <h5
                                className="fw-bold mb-1"
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    color: '#000',
                                    paddingLeft: '10px',
                                }}>
                                Alert Summary
                            </h5>
                        </div>
                    </div>
                </div>

                <div
                    className="report-alert-card my-2 p-1"
                    style={{
                        width: '100%',
                        boxShadow: '0px 0px 35px 0px rgba(154, 161, 171, 0.15)',
                        position: 'relative',
                        height: 'auto',
                    }}>
                    {/* sirf container aur spacing change */}
                    <div
                        className="container-fluid"
                        style={{
                            paddingLeft: '10px',
                            paddingRight: '10px',
                        }}>
                        <form>
                            <div className="row d-flex gx-3 gy-2 align-items-baseline">
                                {/* Start Date Picker */}
                                <div className="col-md-3 form-group">
                                    <label htmlFor="startDate">Start Date</label>

                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedStartDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => setSelectedStartDate(date)}
                                        />
                                    </div>
                                </div>

                                {/* End Date Picker */}
                                <div className="col-md-3 form-group">
                                    <label htmlFor="endDate">End Date</label>

                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            defaultValue="2024-08-22"
                                            id="endDate"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedEndDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => {
                                                setSelectedEndDate(date);
                                            }}
                                        />
                                    </div>
                                </div>

                                <MultiSelectDropdown
                                    label="Zones"
                                    id="zoneSelect"
                                    options={zones}
                                    selectedValues={selectedZones}
                                    onChange={setSelectedZones}
                                />

                                <MultiSelectDropdown
                                    label="Divisions"
                                    id="divisionSelect"
                                    options={divisions}
                                    selectedValues={selectedDivisions}
                                    onChange={setSelectedDivisions}
                                />

                                <MultiSelectDropdown
                                    label="Station"
                                    id="stationSelect"
                                    options={stations}
                                    selectedValues={selectedStation}
                                    onChange={setSelectedStation}
                                />

                                <MultiSelectDropdown
                                    label="Assets Type"
                                    id="assetsSelect"
                                    options={assetsType}
                                    selectedValues={selectedAssetsType}
                                    onChange={setSelectedAssetsType}
                                />

                                <MultiSelectDropdown
                                    label="Alert Type"
                                    id="alertSelect"
                                    options={alertType}
                                    selectedValues={selectedAlertType}
                                    onChange={setSelectedAlertType}
                                />

                                <MultiSelectDropdown
                                    label="Assets Number"
                                    id="assetsNumberSelect"
                                    options={assetsNumber}
                                    selectedValues={selectedAssetsNumber}
                                    onChange={setSelectedAssetsNumber}
                                />

                                <MultiSelectDropdown
                                    label="Cause"
                                    id="causeSelect"
                                    options={causes}
                                    selectedValues={selectedCauses}
                                    onChange={setSelectedCauses}
                                />

                                <MultiSelectDropdown
                                    label="View"
                                    id="viewSelect"
                                    options={viewOptions}
                                    selectedValues={selectedViews}
                                    onChange={(e) => {
                                        handleSelectView(e);
                                    }}
                                    isMulti={false}
                                />

                                <div className="col-auto ms-auto d-flex flex-column">
                                    <label style={{ visibility: 'hidden', marginBottom: '0.25rem' }}>Submit</label>
                                    <button
                                        type="button"
                                        className="btn"
                                        disabled={isFetching}
                                        onClick={() => getAlertSummaryData(5, 1)}
                                        style={{
                                            backgroundColor: '#F9B74C',
                                            color: 'black',
                                            fontWeight: 'bold',
                                            width: '150px',
                                            textTransform: 'uppercase',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '14px',
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                {(!selectedViews || selectedViews?.value === 'table') && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0  text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <span
                            onClick={downloadSummaryExcel}
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                border: '1px solid #ccc',
                                padding: '10px 10px',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                            <i className="fa fa-download"></i>
                        </span>

                        <Table
                            columns={alertSummaryColumns}
                            data={data}
                            pageSize={limit}
                            pageCount={pageCount}
                            pageNumber={pageNumber}
                            totalCount={totalCount}
                            sizePerPageList={sizePerPageList}
                            isSortable={true}
                            pagination={true}
                            isSearchable={true}
                            onPageChange={handlePageChange}
                            onPageClick={handlePageClick}
                        />

                        {data?.length === 0 && <div className="text-center py-4 text-muted">No records found</div>}
                    </div>
                )}

                {selectedViews?.value === 'pie' && pieData?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <PieChartComponent data={pieData || []} />
                    </div>
                )}

                {selectedViews?.value === 'bar' && barData?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <BarChartComponent data={barData || []} />
                    </div>
                )}

                {selectedViews?.value === 'graph' && graphData?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <GraphChartComponent data={graphData || []} />
                    </div>
                )}
            </div>

            <div className="modal fade" id="statusModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-2">{statusMessage}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AlertSummary;
